import React, {useContext} from "react";
import PropTypes from "prop-types";
import sortBy from "lodash/sortBy";

import UIPopupContext from "../UIPopupContext";
import {getDisplayFabricatorName, getReferralPrograms} from "./referralPopupApi";


const ReferralPopupContentListReferrerItem = (props) => {

  const {style, fabricator} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const onFabricatorClick = async () => {
    uiPopupDispatch({activeFabricatorId: fabricator.id, isLoadingReferrals: true});
    const response = await getReferralPrograms(fabricator.id);
    console.log("getReferralPrograms response", response);
    const referrals = response || [];
    const getSortedFabs = () => {
      const filteredList = uiPopupContext.fabricatorsListLeft.filter(fab => fab.id !== fabricator.id);
      if (!referrals.length) {
        return filteredList;
      }
      return sortBy(filteredList, [(fabricator) => {
        return referrals.some(referralObject => referralObject.childFabricatorId === fabricator.id
          && (referralObject.enabled || referralObject.percentage || referralObject.qcPercentage)) ? 0 : 1
      }, (fabricator) => {
        const foundReferral = referrals.find(referralObject => {
          return referralObject.childFabricatorId === fabricator.id
        })
        return foundReferral && foundReferral.enabled ? 0 : 1
      }])
    }
    uiPopupDispatch({
      referrals,
      isLoadingReferrals: false,
      fabricatorsListRight: getSortedFabs(),
    });
  }

  return (
    <div style={style}
         onClick={onFabricatorClick}
         className={"ui-list-li link pl-075 pb-05 pt-05 border-box flex flex--center flex--start"
           + (uiPopupContext.activeFabricatorId === fabricator.id ? " sales-person-list__item--active" : "")}>
      <span className="pr-two-lines">
        {getDisplayFabricatorName(fabricator)}
      </span>
    </div>
  )
};

ReferralPopupContentListReferrerItem.propTypes = {
  style: PropTypes.object.isRequired,
  fabricator: PropTypes.object.isRequired,
}

export default ReferralPopupContentListReferrerItem
